import React, { useState, useEffect } from 'react';
import { resume } from '../assets';
import { Download } from 'lucide-react';


const Resume = () => {
    const resumePdfUrl = resume;
    const [showPopup, setShowPopup] = useState(false);
    const [progress, setProgress] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        if (window.innerWidth < 1024) {
            setShowPopup(true);
            const duration = 5000;
            const interval = 50;
            const steps = duration / interval;
            let currentStep = 0;

            const timer = setInterval(() => {
                currentStep++;
                setProgress((currentStep / steps) * 100);

                if (currentStep >= steps) {
                    clearInterval(timer);
                    setShowPopup(false);
                }
            }, interval);

            return () => {
                clearInterval(timer);
                window.removeEventListener('resize', checkMobile);
            };
        }
    }, []);

    const getColor = (progress) => {
        if (progress < 50) return `rgb(${progress * 2.55}, 255, 0)`;
        return `rgb(255, ${255 - (progress - 50) * 5.1}, 0)`;
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = resumePdfUrl;
        link.download = 'resume.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="flex flex-col items-center lg:ml-[17em] lg:mr-[1em] mt-3 lg:mt-[0] justify-center min-h-screen overflow-x-hidden pb-[1em] px-7 lg:px-0">
            <div className="flex flex-row h-full w-full mt-6">
                {isMobile ? (
                    <div className="w-full flex flex-col items-center justify-center p-4 space-y-4">
                        <p className="text-lg font-suwannaphum text-gray-700 text-center">
                            Resume preview is only available on laptop or desktop devices.
                        </p>
                        <button
                            onClick={handleDownload}
                            className="font-semibold text-[1em] leading-[2em] text-black min-h-[52px] px-4 flex items-center space-x-2 border border-black font-suwannaphum text-black hover:bg-gray-400"
                        >
                            <Download size={20} />
                            <span className='font-suwannaphum'>Download Resume</span>
                        </button>
                    </div>
                ) : (
                    <iframe
                        src={resumePdfUrl}
                        width="100%"
                        height="900"
                        title="Resume PDF"
                        className="border rounded-md"
                    />
                )}
            </div>

            {showPopup && (
                <div className="fixed bottom-6 right-4 bg-white border border-gray-200 rounded-lg shadow-lg p-3 max-w-xs transition-all duration-300 ease-in-out z-50">
                    <p className="text-sm font-suwannaphum text-gray-700 mb-2">
                        Resume preview is not available on mobile devices. Please download to view.
                    </p>
                    <div className="w-full h-1 bg-gray-200 rounded-full overflow-hidden">
                        <div
                            className="h-full transition-all duration-50 ease-linear"
                            style={{
                                width: `${progress}%`,
                                backgroundColor: getColor(progress)
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Resume;